import CategoryCallout from './component'

export default CategoryCallout
